import React from "react";
import {logout} from "../../helpers/authenticator";

export const UserDropdown = () => {
    return (<div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <a className="dropdown-item" href="/home">Request Delivery</a>
        <a className="dropdown-item" href="/deliveries/history">My Deliveries</a>
        <a className="dropdown-item" href="/account">Account</a>
        <div className="dropdown-divider"></div>
        <a className="dropdown-item" onClick={() => {
            logout()
        }} href="#">Log out</a>
    </div>);
};

export const RiderDropdown = () => {
    return (<div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <a className="dropdown-item" href="/home">Home</a>
        <a className="dropdown-item" href="/deliveries/history">Deliveries</a>
        <a className="dropdown-item" href="/account">Account</a>
        <div className="dropdown-divider"></div>
        <a className="dropdown-item" onClick={() => {
            logout()
        }} href="#">Log out</a>
    </div>);
};

export const CourierDropdown = () => {
    return (<div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <a className="dropdown-item" href="/home">Home</a>
        <a className="dropdown-item" href="/add/rider">Add Rider</a>
        <a className="dropdown-item" href="/account">Account</a>
        <div className="dropdown-divider"></div>
        <a className="dropdown-item" onClick={() => {
            logout()
        }} href="#">Log out</a>
    </div>);
};

